import {TheBorderXSplitSymbol} from "../reels/TheBorderXSplitSymbol";
import {ISymbolPosition} from "../../core/reel/ReelInterfaces";
import {TheBorder} from "../TheBorder";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-05-10.
 */

export class TheBorderXSplitSymbols {

    private _xSplitSymbols: TheBorderXSplitSymbol[];

    constructor() {
    }

    private static createNewXSplitSymbol(): TheBorderXSplitSymbol {
        return new TheBorderXSplitSymbol();
    }

    public init(): void {
        this._xSplitSymbols = [];
        for (let i: number = 0; i < 6; i++) {
            this._xSplitSymbols.push(TheBorderXSplitSymbols.createNewXSplitSymbol());
        }

        const tempSym: TheBorderXSplitSymbol = TheBorderXSplitSymbols.createNewXSplitSymbol();
        TheBorder.gpuPushView.addChild(tempSym);
        tempSym.visible = true;
        gsap.timeline({delay:TheBorder.gpuPushView.delay}).add(tempSym.getLandingAndIdleAnimation().restart());
    }

    public getXSplitSymbol(symbolPositionData: ISymbolPosition): TheBorderXSplitSymbol {
        for (let i: number = 0; i < this._xSplitSymbols.length; i++) {
            if (!this._xSplitSymbols[i].isUsed) {
                this._xSplitSymbols[i].isUsed = true;
                this._xSplitSymbols[i].isRemoved = false;
                this._xSplitSymbols[i].reelId = symbolPositionData.reelId;
                this._xSplitSymbols[i].reelPosition = symbolPositionData.startPosition;
                return this._xSplitSymbols[i];
            }
        }
        this._xSplitSymbols.push(TheBorderXSplitSymbols.createNewXSplitSymbol());
        return this.getXSplitSymbol(symbolPositionData);
    }

    public getXSplitSymbolOnReelArea(reel: number, row: number): TheBorderXSplitSymbol {
        for (let i: number = 0; i < this._xSplitSymbols.length; i++) {
            if (this._xSplitSymbols[i].isUsed && this._xSplitSymbols[i].reelId === reel && this._xSplitSymbols[i].reelPosition === (row + 1)) {
                return this._xSplitSymbols[i];
            }
        }
        throw new Error("No active XSplit symbol on reel " + reel + " row: " + row);
    }

    public turnOffAllXSplitSymbols(): void {
        for (let i: number = 0; i < this._xSplitSymbols.length; i++) {
            if (this._xSplitSymbols[i].isUsed) {
                this._xSplitSymbols[i].turnOffSymbolSpine();
            }
        }
    }
}